import React from 'react';

const EngagementPanelImage: React.FC<{
  image: ImageField<ReusableImageField>;
}> = ({ image }) => {
  const { scale, offset } = image;

  const imageStyle = {
    '--translate-x': `${offset?.horizontal ?? 0}rem`,
    '--translate-y': `${offset?.vertical ?? 0}rem`,
    '--scale-x': scale?.x ?? 1,
    '--scale-y': scale?.y ?? 1,
  } as React.CSSProperties;

  return (
    <div className='relative ml-8 h-full max-h-full w-1/4 max-w-full lg:hidden'>
      <img
        src={image.src}
        alt={image.alt}
        className='engagement_panel__cover absolute left-0 top-0 h-full'
        style={imageStyle}
      />
    </div>
  );
};

export default EngagementPanelImage;
